import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {DocumentSeriesForm} from './components/DocumentSeriesForm';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('entity.document.labels.seriesTitle'),
    href: settingsRoutes.seriesDefinition,
  },
];

export function SeriesDefinitionNew() {
  const title = i18n.t('entity.documentSeries.actions.newSeries');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate header={{breadcrumbs, title}} data-testid="general-document-series-modal">
        <DocumentSeriesForm />
      </SettingsTemplate>
    </>
  );
}
